<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #StockTakeForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="stockTake.id">{{ l('EditStockTake') }}</span>

                        <span *ngIf="!stockTake.id">{{ l('CreateNewStockTake') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="my5">
                        <label class="form-label" for="StockTake_StockTakeDate">{{ l('Date') }}</label>
                        <!--<input type="text"
           id="StockTake_StockTakeDate"
           class="form-control"
           [(ngModel)]="stockTake.stockTakeDate"
           name="StockTakeDate" />-->
                        <abp-datetime-picker #AddStock_date="ngModel" [(ngModel)]="stockTake.stockTakeDate"
                                             id="AddStock_date" name="StockTake_stockTakeDate"
                                             [bsConfig]="{ adaptivePosition: true }"></abp-datetime-picker>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="StockTake_Name">{{ l('Name') }} *</label>
                        <input type="text"
                               #StockTake_Name="ngModel"
                               id="StockTake_Name"
                               class="form-control"
                               [(ngModel)]="stockTake.stockTakeName"
                               name="Name"
                               minlength="0"
                               maxlength="100"
                               required />
                        <validation-messages [formCtrl]="StockTake_Name"></validation-messages>
                    </div>

                    <div class="my5">
                        <label class="form-label" for="StockTake_Remarks">{{ l('Remarks') }}</label>
                        <input type="text"
                               id="StockTake_Remarks"
                               class="form-control"
                               [(ngModel)]="stockTake.remarks"
                               name="Remarks" />
                    </div>



                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-danger" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!StockTakeForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
